var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTextAa = function SvgIconTextAa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03 4.824a1 1 0 0 0-1.81 0l-4.208 8.944a1 1 0 0 0-.055.115L.22 17.574a1 1 0 1 0 1.81.852l1.495-3.176h7.2l1.495 3.176a1 1 0 0 0 1.81-.852l-1.734-3.686a1 1 0 0 0-.06-.125zm1.755 8.426-2.66-5.651-2.66 5.651zM21.125 12.6a4.45 4.45 0 0 0-2-.475c-2.043 0-4 1.428-4 3.531s1.957 3.531 4 3.531c.782 0 1.55-.209 2.202-.584A1 1 0 0 0 23.125 18v-5.728c0-2.126-1.916-3.624-3.997-3.625a4.3 4.3 0 0 0-2.441.746 1 1 0 0 0 1.127 1.652 2.3 2.3 0 0 1 1.305-.398h.006c1.237 0 2 .846 2 1.625zm-2 1.525c-1.27 0-2 .838-2 1.531s.73 1.531 2 1.531 2-.838 2-1.53c0-.694-.73-1.532-2-1.532"
  }))));
};
export default SvgIconTextAa;